function LayoutTop() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
      <path
        fill="#FF2D55"
        fillRule="evenodd"
        d="M14 1a1 1 0 00-1-1H1a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V1zm-.875 4a1 1 0 00-1-1H1.875a1 1 0 00-1 1v7a1 1 0 001 1h10.25a1 1 0 001-1V5z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default LayoutTop
